var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("文字按钮")]),_c('el-button',{attrs:{"type":"text"}},[_vm._v("文字按钮")]),_c('el-button',{attrs:{"type":"text"}},[_vm._v("文字按钮")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }